export const HOMEPAGE_GENERIC_GREETING = "What are you looking for?";

export const TICKET_DISPLAY_NUM = 4;

export const TICKET_CANCEL_TITLE = "Are you sure you want to cancel request";
export const TICKET_CANCEL_NO = "NO";
export const TICKET_CANCEL_YES = "PLEASE DO IT!";

export const TICKET_COMMENT_TITLE = "Submit feedback related to request";
export const TICKET_COMMENT_DESCRIPTION =
  "Specify feedback to be added to this request.";
export const TICKET_COMMENT_INPUT_PLACEHOLDER = "Type your feedback here *";
export const TICKET_COMMENT_SUBMIT = "POST FEEDBACK";

export const RECOMMENDATION_TYPE_ACTION = "ACTION";
export const RECOMMENDATION_TYPE_SERVICE = "SERVICE";
export const QUICK_SOLUTIONS_MAX_COUNT = 8;

export const SERVER_ERROR_MESSAGE =
  "An error has occurred . Please try again. If the problem persists, please contact support.";

export const IT_SERVICES = "IT services";
export const IT_BUSINESS_SERVICES = "IT business services";
export const SPECIALIZED_SERVICES = "19";
export const SERVICE_DIRECTORY = " service directory";
export const IT_PLATFORM = "IT";
export const HR_PLATFORM = "HR";
export const HR_SERVICES_AREA = "HR Services";
export const HR_DIRECTORY = "AskHR";
export const SALES_DIRECTORY = "SALES";
export const ALL_SERVICE_DIRECTORY = "ALL";
export const NON_IT_SERVICES = "";
export const EH_ABOUT_PAGE = "about-employee-hub";
export const IT_SERVICE_DIRECTORY = IT_PLATFORM + SERVICE_DIRECTORY;
export const ENTERPRISE_SERVICE_DIRECTORY = "Enterprise" + SERVICE_DIRECTORY;
export const AUTODESK_ONE_ENTERPRISE_SEARCH = "Autodesk One - Enterprise search";

//Service Browser Constants
export const NBR_SUB_CATEGORIES_IN_NAV = 3;
export const DELAY_BETWEEN_MULTI_SERVICE_LOAD_IN_MILLIS_DEEP_LINK_USECASE = 100;
export const DELAY_BETWEEN_MULTI_SERVICE_LOAD_IN_MILLIS = 800;

export const ERROR_MESSAGE =
  "There was an error that wasn’t your fault. Go get a cup of coffee, come back, and try again later or contact support.";
export const INVALID_PLATFORM =
  "An error has occurred due to invalid input data (Platform category). Please contact support.";

export const EMPLOYEE_HUB_HR_SECURE_READ_ROLE =
  "EMPLOYEE_HUB_PLATFORM_HR_SECURE_READ";
export const navigationArrow = {
  navigationPrev:
    '<span><svg data-v-526c0dc0="" aria-hidden="true" data-prefix="fas" data-icon="chevron-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-chevron-left fa-w-10"><path data-v-526c0dc0="" fill="#0696D7" d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z" class=""></path></svg></span>',
  navigationNext:
    '<span><svg data-v-526c0dc0="" aria-hidden="true" data-prefix="fas" data-icon="chevron-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-chevron-right fa-w-10"><path data-v-526c0dc0="" fill="#0696D7" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" class=""></path></svg></span>'
};

export const SLACK_HELPBOT_URL = "https://autodesk.slack.com/app_redirect?app=ACC0W92MC"

export const DES_CHAT_URL = SLACK_HELPBOT_URL

export const SERVICENOW_PRODURL_PATTERN =
  "https://autodesk.service-now.com/askhr?id=askhr_kb_article&amp;sys_id=";

export const SNOW_PRODURL = "https://autodesk.service-now.com";

export const HH_URL = "https://helphub.autodesk.com";

export const PAGINATION_PER_PAGE = 15;

export const PAGINATION_FIRST_PAGE = 1;

export const CAPITALIZE_ALL_TEXT = "All";

export const LOWER_CASE_ALL_TEXT = "all";

export const LOAD_STATE_LOADING = "loading";

export const LOAD_STATE_LOADED = "loaded";

export const LOAD_STATE_NONE = "none";

export const WARN_NO_USER_DATA = "Could not retrieve user data for user: ";

export const WARN_NO_PROFILE_PIC =
  "Could not retrieve profile picture for user: ";

export const URL_MATCHER = /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/gim;

export const PASSWORD_EXPIRE_DAYS = 90;

export const IT_HELPBOT = "IT Helpbot";

export const IT_CALL_BACK_REQUEST = "Schedule a call back";

export const DLI_LINK = "https://employeehub.autodesk.com/apps/digital-life-insights/"

export const LUMI_SLACK_LINK = "https://autodesk.slack.com/app_redirect?app=A02QRD6227M"
export const ANNOUNCEMENT_BANNER = {
  message: `Lumi, Autodesk's employee virtual assistant, is now available for US employees! <a href=${LUMI_SLACK_LINK} target="_blank">Click here</a> to start engaging with Lumi.`
};
export const DLI_ANNOUNCEMENT_BANNER = `Digital Life Insights is now available for COO employees in AMER and APAC! Discover your personalized insights <a href="${DLI_LINK}" target="_blank">here</a>.`;

export const STOCK_PROGRAM_LINK = "https://employeehub.autodesk.com/pages/stock-programs";
export const STOCK_401K_LINK = "https://employeehub.autodesk.com/pages/401k";
export const STOCK_PROGRAM_ANNOUNCEMENT_BANNER = `Check out the updated <a href="${STOCK_PROGRAM_LINK}" target="_blank">Stock Programs</a> & <a href="${STOCK_401K_LINK}" target="_blank">US 401(k)</a> resources, including on-demand recordings to learn plan basics in minutes!`;

export const HIRING_MANAGER_LINK = "https://employeehub.autodesk.com/apps/hiring-manager-center/";

export const IMAGES_CLOUDFRONT_BASE_URL = "https://d3f4c2m8125kdg.cloudfront.net/hiring-manager-center";

export const SAFETY_AND_SECURITY_LINK = "https://share.autodesk.com/sites/SafetyandSecurity";
export const INCIDENT_REPORTING_LINK = "https://us.core.resolver.com/#/go/d2aa42ea844a82f52611746c64357ac1978f669ba3dc5d605f9a16882d221890f889099927234511ba00e01650e35246931615b8739e0884433b0148e3630c5a";

export const CONTACT_SUPPORT_LIST = [
  {
    title: "Facilities",
    description:
      "Support for new or replacement badges, workstation setup, reporting in-office issues with temperature, cleaning, A/V, and more.",
    actions: [
      {
        text: "Open a Facilities ticket",
        url: WOLKEN_BASE_URL +WOLKEN_FORMS_RESOURCE_URL +"?itemId=2331",
        target: "_blank"
      },
    ],
  },
  {
    title: "AskPPL",
    description:
      "Support for benefits, payroll, flexible work, hire/exit process, policies, Workday, and other PPL inquiries.",
    actions: [
      {
        text: "Open an AskPPL case",
        url: WOLKEN_BASE_URL +WOLKEN_FORMS_RESOURCE_URL +"?itemId=2203&requestTypeId=40",
        target: "_self"
      },
    ],
    isStandardContent: true
  },
  {
    title: "IT",
    description:
      "Support for applications, access, technical issues, and more.",
    actions: [
      {
        text: "IT HelpBot",
        url: SLACK_HELPBOT_URL,
        note: "(Instant help)",
        isHidden: true
      },
      {
        text: "Schedule a call back",
        triggerFn: (that) => that.$parent.$parent.$refs.footerWebComponent.getVueInstance().openCallSupport()
      },
      {
        text: "Email us",
        url: "mailto:esehelp@autodesk.com",
        target: "_blank"
      },
    ],
  },
  {
    title: "Procurement",
    description:
      "Support for Ariba, Supplier Central, Concur, hiring contingent workers, purchasing software, and more.",
    actions: [
      {
        text: "Ask Procurement via Lumi",
        url:  LUMI_SLACK_LINK,
        target: "_blank"
      },
    ],
  },
  {
    title: "Legal",
    description:
      "Support for connecting to the right contact person in Legal, as well as Legal resources, forms, and policies.",
    actions: [
      {
        text: "Ask Legal",
        url: WOLKEN_BASE_URL +WOLKEN_FORMS_RESOURCE_URL +"?itemId=2358&requestTypeId=41",
        target: "_self"
      },
    ],
  },
  {
    title: "Stock & 401(K)",
    description:
      "Support for 401(k), ESPP, restricted stock, deferred compensation, and more.",
    actions: [
      {
        text: "Contact the Stock Administration team",
        url: WOLKEN_BASE_URL +WOLKEN_FORMS_RESOURCE_URL +"?itemId=2225&requestTypeId=40",
        target: "_self"
      },
    ],
    isStandardContent: true
  },
  {
    title: "Marketing",
    description:
      "Support for marketing dashboards, campaign management, Folloze, Draftr, etc.",
    actions: [
      {
        text: "Contact Marketing Operations",
        url: `${ADSK_ONE_BASE_URL}/BSM/articles/9ac7588a1bed24543cdb98e02a4bcbde`,
        target: "_self"
      },
    ],
  },
  {
    title: "Safety & Security",
    description:
      "Support for safety trainings, event safety, reporting workplace injuries, bringing chemicals on site, and more. ",
    actions: [
      {
        text: "Contact Safety & Security",
        url: SAFETY_AND_SECURITY_LINK,
        target: "_blank"
      },
      {
        text: "Report a safety or security incident",
        url: INCIDENT_REPORTING_LINK,
        target: "_blank"
      },
    ],
  },
];


export const FROALA_KEY = 'bMA6aC5A5B2B2H3D1H2yQNDMIJg1IQNSEa1EUAi1XVFQd1EaG3C2A5C3C4E3D2D4G2H1==';

export const PAGINATION_THRESHOLD = 10;

export const MAX_BOOKMARKS_ON_HOMEPAGE = 5;

export const APPLICATION_ACCESS_DASHBOARD_LINK = 'https://employeehub.autodesk.com/apps/application-access-dashboard/view/recommendations'

export const BOOKMARK_ADDED_SUCCESS = " has been successfully bookmarked";

export const BOOKMARK_REMOVED_SUCCESS =
  " has been removed from bookmarks. The bookmark will be available on this page until refreshed.";

export const INJECT_BOOKMARK_COMPONENT = "eh-bookmark-component";

export const SNOW_KB_FEEDBACK_RESOURCE_URL = "/api/now/table/kb_feedback";
export const SNOW_KB_FEEDBACK_TASK_RESOURCE_URL = "/api/now/table/kb_feedback_task";

export const AUTODESK_ONE_WOLKEN_PROXY_FEEDBACK_URL = "/kbfeedbackbyarticleid";

export const GRAPH_BASE_URL = "https://graph.microsoft.com/v1.0";

export const SITE_ID = "6a537581-a8c3-4a8a-954a-10935dd20555";

export const DLI_BANNER_SEC_GROUP_QUERY = "Digital Life Insights";
export const DLI_BANNER_SEC_GROUP_ID = "3ba083aa-12e0-4f01-a387-42047d961471";

export const VIRTUAL_ASSISTANT_US_REG_EMPLOYEES = "ad7c4482db81cd903bb20825ca961978"

export const MICROSOFT_GRAPH_AUTH_ERROR = "error throw by the authentication handler"

export const OUTAGE_BANNER_YELLOW = "Yellow";
export const OUTAGE_BANNER_GREEN = "Green";
export const OUTAGE_BANNER_RED = "Red";

export const FALLBACK_ADSK_LOGO_IMG_URL = "https://d3f4c2m8125kdg.cloudfront.net/Autodesk_appsquare_black.svg";
export const ALL_EVENTS_LINK = "https://share.autodesk.com/sites/One/SitePages/Events.aspx"

export const HOMEPAGE_DEFAULT_HERO_IMG = "https://d3f4c2m8125kdg.cloudfront.net/homebase/homebase-banner-background-v2.png";

export const EMPLOYEE_HUB_HOST_SUBSTRING = "employeehub";
export const ADSK_ONE_HOST_SUBSTRING = "one-";

export const REGION_NAME_AMER = "AMER";
export const REGION_NAME_APAC = "APAC";
export const REGION_NAME_EMEA = "EMEA";

export const APPLICATION_ACCESS_DASHBOARD_LINK_ALL = 'https://employeehub.autodesk.com/apps/application-access-dashboard/all';

export const PAGE_LOAD_EVENT_LOAD_HEADER = "HomePage: Load AutodeskOne Header";

export const PAGE_LOAD_EVENT_TOP_STORIES_SECTION = "HomePage: Top stories at Autodesk section";

export const PAGE_LOAD_EVENT_RIGHT_PANEL_SECTION = "HomePage: Right panel section";

export const PAGE_LOAD_EVENT_NEWS_SECTION = "HomePage: News based on your interests section";

export const PAGE_LOAD_EVENT_EMPLOYEE_RESOURCE_SECTION = "HomePage: Employee resources section";

export const API_EVENT_FETCH_PLATFORM_CATEGORIES= "Fetch Platform Categories";

export const INTEGRATED_SYS_ERROR_WARNING = "We are experiencing issues with an integrated system, Please try again later after sometime.";

export const LEFT_NAVIGATION = "left";

export const RIGHT_NAVIGATION = "right";

export const LUMI_CAMPAIGN_BANNER = "Standard with Lumi Icon";

export const NEWS_SUMMARY_COMPLETE_STATE = "summarize_news_completed";

export const NEWS_SUMMARY_PATH = "/news-summary"
export const VIDEO_POPUP_CAMPAIGN_FIRST_TIME_VISIT_KEY = "has-visited-video-campaign-state";

export const LAMBDA_TIMEOUT_ERROR = "Lambda:ExecutionTimeoutException";

export const NEWS_SUMMARY_EMAIL_SUBJECT = "Check out today's news summary on Autodesk One!"
export const NEWS_SUMMARY_EMAIL_BODY = `View today's news highlights from top stories at the below link.\n https://one.autodesk.com/news-summary\n`